import React from 'react';
import LayoutContainer from './Container';
import Story from './TenMinuteStory';
import '../styles/maincontent.css';

const TenMinute = () => {
  const petitionURL = "https://petition.parliament.uk/petitions/660652";

  return (
    <LayoutContainer>
      <div className="main-content">
        <div className="content-row align-items-center">
          <a href={petitionURL} target="_blank" rel="noopener noreferrer" className="qr-image-container">
            <img src="images/qr-code.jpg" alt="QR Code" className="img-fluid qr-col" />
          </a>
          <h1 className="left-title">Petition for debate in 10 minutes</h1>
        </div>
        {/* 10 minute story */}
        <Story />
      </div>
    </LayoutContainer>
  );
}

export default TenMinute;

